import { useCalendarContext } from 'components/features/Calendar';
import { EventsAndTimeslots } from 'types/Event';
import DayEvent from './DayEvent';
import useStyles from './DayEventList.styles';

type DayEventListPureProps = {
  selectedDayEventsAndTimeslots: EventsAndTimeslots;
};

const DayEventListPure = ({
  selectedDayEventsAndTimeslots,
}: DayEventListPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {selectedDayEventsAndTimeslots.map((eventOrTimeslot, index) => (
        <DayEvent eventOrTimeslot={eventOrTimeslot} key={index} />
      ))}
    </div>
  );
};

const DayEventList = (): JSX.Element | null => {
  const { selectedDayEventsAndTimeslots } = useCalendarContext();

  return (
    <DayEventListPure
      selectedDayEventsAndTimeslots={selectedDayEventsAndTimeslots}
    />
  );
};

export default DayEventList;
